<div class="o-flex o-flex--grids align-items-center border-container pt-2 pb-2">
  <div class="o-flex__item u-flex-1/5@tablet u-flex-1/1@mobile u-flex-1/1@small pt-2 pb-2">
    <p class="mb-0 float-right text-xs-center float-xs-left">
        <em class="icon-trash" (click)="usunUszkodzenie({identyfikatorUszkodzenia: uszkodzenie.identyfikator})" title="Usuń">
            <img src="assets/images/trash_bin.png" alt="Usuń">
        </em>
    </p>
  </div>
</div>
